import * as Functions from './functions';

$(function () {
    $('#adsBarCloseBtn').on('click', function () {
        $('.ads-bar').addClass('hidden').fadeOut();
        Cookies.set('addBarHidden', true)
    });

    new Swiper('#brandCarousel', {
        mode: 'horizontal',
        slidesPerView: 8,
        // pagination: '.carousel0',
        //paginationClickable: true,
        //nextButton: '.swiper-button-next',
        //prevButton: '.swiper-button-prev',
        autoplay: true,
        speed: 500,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 2
            },
            480: {
                slidesPerView: 3
            },
            640: {
                slidesPerView: 4
            },
            991: {
                slidesPerView: 6
            },
            1200: {
                slidesPerView: 8
            }
        },
        on: {
            init: function (swiper) {
                $(swiper.$el).removeClass('loading');
            },
        },
    });

    new Swiper('.product-swiper', {
        mode: 'horizontal',
        slidesPerView: 5,
        autoplay: false,
        pauseOnMouseEnter: true,
        speed: 500,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    new Swiper(".homeSwiper", {
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
        },
        autoplay: true,
        pauseOnMouseEnter: true,
        speed: 500,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    let tabSwiperD = $('.tabSwiper');
    if (tabSwiperD.length){
        let tabSwiper = new Swiper('.tabSwiper', {
            autoplay: true,
            slidesPerView: 1,
            pauseOnMouseEnter: true,
            speed: 700,
            loop: true,
            grabCursor: true,
        }).on('slideChange', function (swiper) {
            $('.tabSwiper-swiper-pagination li').removeClass('active')
            $('.tabSwiper-swiper-pagination a[data-slide-number="' + swiper.activeIndex + '"]').parent().addClass('active')
        });

        tabSwiperD.mouseenter(() => {
            tabSwiper.autoplay.stop();
        });

        tabSwiperD.mouseleave(() => {
            tabSwiper.autoplay.start();
        });

        if ($( window ).width() <= 991){
            tabSwiper.autoplay.stop();
        } else {
            tabSwiper.autoplay.start();
        }

        $('.tabSwiper-swiper-pagination a').on('click', function () {
            tabSwiper.slideTo($(this).data('slide-number'))
        });
    }

    $('#form-language .language-select').on('click', function (e) {
        e.preventDefault();

        console.log($(this).data('lang-code'))
        $('#form-language input[name=code]').val($(this).data('lang-code'));
        $('#form-language').submit();
    });

    /* Search */
    let searchInput = $('#search input[name=\'search\']');
    searchInput.closest('form').find('button').on('click', function (e) {
        e.preventDefault();
        let url = $('base').attr('href') + 'index.php?route=product/search';
        let value = $('#search input[name=\'search\']').val();
        if (value) {
            url += '&search=' + encodeURIComponent(value);
        }

        window.location.href = url;
    });

    searchInput.on('keydown', function (e) {
        if (e.keyCode === 13) {
            $('header #search input[name=search]').closest('form').find('button').trigger('click');
        }
    });

    /* Modal */
    $(document).on('click', '.modal-opener', function () {
        Functions.openFullModal({
            title: $(this).data('title'),
            actionButton: $(this).data('action-button'),
            showProgressBar: $(this).data('progress-bar'),
            modalBodyContent: $(this).data('modal-body-content'),
        });
    });

    $('#checkCartBalance').on('click', function () {
        let checkCartBalanceModal = Functions.openFullModal({
            modalTitle: $(this).data('title'),
        });

        checkCartBalanceModal.addClass('--small-width');

        $.post('/index.php?route=ajax/cartbalance', {}, function (response) {
            checkCartBalanceModal.find('.modal-body').html(response);
        }, 'html');
    });

    $(document).on('input', 'input[name=cartNumber]', function (){
        $('.attachCardToAccount, .checkBalanceResult').attr('style', 'display: none !important;');
    });

    $(document).on('click', '.attachCardToAccount', function (e) {
        e.preventDefault();

        let checkCartBalanceForm = $('.checkCartBalanceForm'),
            verifyDiscountCardForm = $('.verifyDiscountCardForm'),
            phoneNumberIsValid = $('input[name=phoneNumberIsValid]').val(),

            text_phone_number_not_found = $('input[name=text_phone_number_not_found]').val();

        if ($('#userProfileBtn').data('is-logged') !== 1){
            window.location.href = '/index.php?route=account/discount_card';
            return false;
        }

        if (!phoneNumberIsValid){
            Swal.fire({
                icon: 'error',
                html: text_phone_number_not_found,
            })
            return false;
        }

        $(checkCartBalanceForm).find('button, input').attr('disabled', true);

        let cartNumber = checkCartBalanceForm.find('input[name=cartNumber]').val(),
            csrf_token = checkCartBalanceForm.find('input[name=csrf_token]').val();
        $.post('/index.php?route=ajax/cartbalance/attach', {csrf_token, cartNumber}, function (response) {
            if (response.success){
                checkCartBalanceForm.hide();
                verifyDiscountCardForm.html(response.html);
                verifyDiscountCardForm.show();
            } else {
                Swal.fire({
                    icon: 'warning',
                    text: response.message,
                })
            }
            $(checkCartBalanceForm).find('button, input').removeAttr('disabled');
        }, 'json');
    });

    $(document).on('submit', '.checkCartBalanceForm', function (e) {
        e.preventDefault();
        let checkCartBalanceForm = $(this),
            checkBalanceResultDiv = $('.checkBalanceResult'),
            buttonText = checkCartBalanceForm.find('.buttonText'),
            buttonLoading = checkCartBalanceForm.find('.buttonLoading'),
            attachCardToAccount = $('.attachCardToAccount');

        $(e.target).find('button, input').attr('disabled', true);
        buttonText.hide(); buttonLoading.show();
        attachCardToAccount.attr('style', 'display: none !important;');

        checkBalanceResultDiv.html('').hide();
        let cartNumber = checkCartBalanceForm.find('input[name=cartNumber]').val(),
            csrf_token = checkCartBalanceForm.find('input[name=csrf_token]').val();

        $.post('/index.php?route=ajax/cartbalance/check', {csrf_token, cartNumber}, function (response) {
            checkBalanceResultDiv.fadeIn().html(response);
            $(e.target).find('button, input').removeAttr('disabled');

            attachCardToAccount.show();
            buttonText.show(); buttonLoading.hide();
        }, 'html');
    });

    $(document).on('submit', '.verifyDiscountCardForm', function (e){
        e.preventDefault();

        let smsVerificationCode = $('input[name=smsVerificationCode]').val(),
            verifyDiscountCardForm = $(this);

        $(verifyDiscountCardForm).find('button, input').attr('disabled', true);
        $.post('/index.php?route=ajax/cartbalance/verify', {sms_verification_code: smsVerificationCode}, function (response) {
            console.log(response)
            if (response.success){
                window.location.href = response.redirect;
            } else {
                Swal.fire({
                    icon: 'error',
                    text: response.message,
                })
                $(verifyDiscountCardForm).find('button, input').removeAttr('disabled');
            }
        }, 'json');
    });

    $('.productPreOrder').on('click', function (){
        let productPreOrderModal = Functions.openFullModal({
            modalTitle: $(this).data('title'),
        });

        let product_id = $(this).data('product-id')

        productPreOrderModal.addClass('--small-width');

        $.post('/index.php?route=ajax/preorder', { product_id }, function (response) {
            productPreOrderModal.find('.modal-body').html(response);
        }, 'html');
    });

    $(document).on('submit', '#productPreOrderForm', function (e){
        e.preventDefault(); e.stopPropagation();

        let this_form = $(e.target),
            product_id = this_form.find('input[name=product_id]').val(),
            email = this_form.find('input[name=email]').val(),
            phone_number = this_form.find('input[name=phone_number]').val();

        this_form.find('input').attr('disabled', true);
        this_form.find('button').attr('disabled', true);

        $.post('/index.php?route=ajax/preorder/order', {product_id, email, phone_number}, function (response) {
            if (response.success){
                $('.alis-full-modal').modal('hide');
                Swal.fire({
                    icon: 'success',
                    text: response.message,
                })
            } else {
                Swal.fire({
                    icon: 'warning',
                    text: response.message,
                })
            }
            this_form.find('input').removeAttr('disabled');
            this_form.find('button').removeAttr('disabled');
        }, 'json');
    });

    $('#userProfileBtn').on('click', function () {
        let userProfileModal = Functions.openFullModal({
            modalTitle: $(this).data('title'),
        });

        userProfileModal.addClass('--small-width');

        $.post('/index.php?route=ajax/account', {is_ajax: true}, function (response) {
            userProfileModal.find('.modal-body').html(response);
            let logoutButton = userProfileModal.find('.logoutButton').clone();
            userProfileModal.find('.modal-action').html(logoutButton);
        }, 'html');
    });

    $('#userCartModal').on('click', function () {
        let userCartModal = Functions.openFullModal();

        $.post('/index.php?route=ajax/cart', {}, function (response) {
            userCartModal.find('.modal-body').html(response);
            let cartTitle = userCartModal.find('.cartTitle')
            userCartModal.find('.modal-title').html(cartTitle.text())
            cartTitle.remove()
        }, 'html');
    });

    $('#button-filter').on('click', function () {
        let filter = [];
        $('input[name^=\'filter\']:checked').each(function () {
            filter.push(this.value);
        });
        window.location.href = '/index.php?route=product/category?filter=' + filter.join(',');
    });

    $('.addProductToCart').on('click', function (){
        let parent_div = $(this).closest('.shop-buttons');
        let product_id = parent_div.find('input[name=product_id]').val();
        let quantityElement = parent_div.find('input[name=quantity]');
        let product_count = parseInt(quantityElement.val()) ? parseInt(quantityElement.val()) : 1;

        cart.add(product_id, product_count);
    });

    $('.shop-buttons .plusMinus').on('click', function (){
        let this_button = $(this);
        let action = this_button.data('action')
        let parent_div = this_button.closest('.shop-buttons');
        let input = parent_div.find('.countAddedProduct');
        let input_val = parseInt(input.val()) ? parseInt(input.val()) : 1;
        let maxVal = parseInt($('.stockResult').text())


        if (action === 'plus'){
            if (input_val < maxVal) {
                input_val += 1
            }
        } else {
            input_val -= 1
        }
        if (input_val < 1) {
            input_val = 1;
        }
        input.val(input_val);
    });

    $('input[name=quantity]').on('input', function (){
        let input = $(this);
        let input_val = parseInt(input.val()) ? parseInt(input.val()) : 1;
        let maxVal = parseInt($('.stockResult').text())

        if ($(this).val().replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')) {
            if (input_val > maxVal){
                input.val(maxVal)
            } else {
                input.val(1);
            }
        } else {
            input.val(1);
        }
    });

    $('.hamburger').on("click", function () {
        $(".hamburger").toggleClass("is-active");
    });

    let storeOrderHistory = $('#storeOrderHistory'),
        storeOrderHistoryTitle = $('#storeOrderHistoryTitle'),
        storeOrderHistoryLoading = $('#storeOrderHistoryLoading');
    if (storeOrderHistory.length) {
        $.post('/index.php?route=ajax/cartbalance/history', {}, function (response) {
            if (response.success){
                storeOrderHistoryTitle.show();
                storeOrderHistory.find('tbody').html(response.html);
                storeOrderHistory.show();
            } else {
                storeOrderHistoryTitle.hide();
                storeOrderHistory.hide();
            }
            storeOrderHistoryLoading.attr('style', 'display: none !important;');
        }, 'json');
    }

    let stockCheckLoading = $('.stockCheckLoading');
    if (stockCheckLoading.length) {
        let product_id = stockCheckLoading.data('product-id'),
            stockResult = stockCheckLoading.closest('.stockCheckParent').find('.stockResult'),
            csrf_token = stockCheckLoading.closest('.stockCheckParent').find('input[name=csrf_token]').val(),
            cantCheckStock = stockCheckLoading.closest('.stockCheckParent').find('.cantCheckStock'),
            shopButtons = $('.shop-buttons');

        shopButtons.find('input, button').attr('disabled', true);

        $.post('/index.php?route=ajax/stock_check', {
            product_id, csrf_token, error_code: '', total_quantity: ''
        }, function (response) {
            if (response.success){
                stockResult.show().removeClass('bg-danger').addClass('bg-success').html(response.data.total_quantity);
                shopButtons.find('input, button').removeAttr('disabled');
            } else {
                // 'error_code' => 0 => OK
                // 'error_code' => 1 => Connection error'
                // 'error_code' => 2 => 'Product model not defined'
                // 'error_code' => 3 => 'Access token is incorrect'
                // 'error_code' => 4 => 'Product not found in stock'
                cantCheckStock.show();
                stockResult.show();
                $('.productPreOrder').show();
            }
            stockCheckLoading.hide();
        }, 'json');
    }

    let popupModal = $('#popupModal');
    if (popupModal.length){
        popupModal.modal('show');
        popupModal.on('hidden.bs.modal', function (){
            Cookies.set('popupModalHidden', true)
        });
    }

    $('#hidePopup').on('click', function () {
        $('#popupModal').modal('hide');
        Cookies.set('popupModalHidden', true)
    });
});